/* eslint-disable camelcase */
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatInternalLink, formatLink } from 'app/utilities/link-helper';

const Treble = ({ isLarge, thumbnail_group: thumbnailGroup, title }) => {
    const trebleClass = classNames('content-block || treble-block || constrain-width', {
        'large': isLarge
    });

    const renderItemContent = (item) => (
        <React.Fragment>
            <h3 className="h4">{renderLink(item.url, item.title)}</h3>
            {item.description && <p className="description">{item.description}</p>}
            <span className="button || cta">{item.cta_text}</span>
        </React.Fragment>
    );

    return (
        <section className={trebleClass}>
            <h2 className="h4">{title}</h2>
            <ul className="item-container">
                {thumbnailGroup.map((item, index) => {
                    return (
                        <li
                            className="item"
                            href={formatLink(item.url)}
                            key={index}
                            style={{ backgroundImage: `url(${item.image})` }}
                        >
                            {renderItemContent(item)}
                        </li>
                    );
                })}
            </ul>
        </section>
    );
};

Treble.propTypes = {
    isLarge: PropTypes.bool.isRequired,
    thumbnail_group: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired
};

export default Treble;

// Render <a> if external url, <Link> if internal url
// eslint-disable-next-line require-jsdoc
function renderLink(url, title) {
    const internalLink = formatInternalLink(url);

    if (internalLink) {
        return <Link className="title" to={internalLink}>{title}</Link>;
    }

    return <a className="title" href={formatLink(url)}>{title}</a>;
}
